export const NothingToSeeYet = () => {
	return (
		<p className="text-[#121212] text-base lg:text-lg font-medium">
			Nothing to see yet
		</p>
	);
};
